import type { SVGProps } from 'react';
const DawnFlagMY = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-MY_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-MY_svg__a)">
      <path
        fill="#E1244A"
        fillRule="evenodd"
        d="M22 0H10.476v1.067H22zm0 2.133H10.476V3.2H22zM10.476 4.267H22v1.066H10.476zM22 6.4H10.476v1.067H22zM0 8.533h22V9.6H0zm22 2.134H0v1.066h22zM0 12.8h22v1.067H0zm22 2.133H0V16h22z"
        clipRule="evenodd"
      />
      <path fill="#0C3F8E" d="M0 0h12.571v8.533H0z" />
      <path
        fill="#FFD34F"
        fillRule="evenodd"
        d="M5.239 7.467c.742 0 1.425-.263 1.962-.701a2.6 2.6 0 0 1-.915.167c-1.446 0-2.619-1.194-2.619-2.666 0-1.473 1.173-2.667 2.62-2.667.321 0 .63.06.914.167a3.1 3.1 0 0 0-1.962-.7c-1.736 0-3.143 1.432-3.143 3.2 0 1.767 1.407 3.2 3.143 3.2m2.233-1.278.91-1.048.909 1.048-.238-1.377 1.371-.07-1.205-.67.8-1.135-1.265.542-.373-1.346L8.01 3.48l-1.266-.542.8 1.135-1.204.67 1.37.07z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagMY;
